<template>
<div class="user_forgetpassword">
  <form v-if="!fgStatus" class="form-forgetpassword">
    <input 
      type="email" 
      name="email" 
      v-focus 
      v-model="email" 
      placeholder="請輸入當初註冊的信箱" />
    <div v-if="comfirm" class="warning">信箱格式錯誤</div>
    <div class="form-submit" @click="submitEmail">送出</div>
  </form>

  <div v-if="fgStatus === 'success'" class="submit-success">
    <h3>密碼已寄送到 {{ email }}</h3>
    <p>已寄發重設密碼連結信件到信箱，請盡快打開信件進行後續設定！</p>
  </div>

  <div v-if="fgStatus === 'fail'" class="submit-fail">
    <p>網頁錯誤，請重新整理再試一次。</p>
  </div>
</div>
</template>

<script>
  import { 
    mapActions,
    mapGetters,
   } from 'vuex';

  export default {
    name: 'user_forget_password',
    data() {
      return {
        comfirm: false,
        email: '',
      };
    },
    computed: {
      ...mapGetters({
        fgStatus: 'getForgetpasswordStatus',
      }),
    },
    methods: {
      ...mapActions([
        'actionForgetPassword',
      ]),
      submitEmail() {
        if (this.email.length > 0) {
          const viewData = {
            email: this.email,
            router: this.$router,          
          };

          this.comfirm = false;
          this.actionForgetPassword(viewData);
          return;
        } 

        this.comfirm = true;
      },
    },
  };
</script>

<style lang="scss">
.user_forgetpassword {
  display: flex;
  flex-direction: column;
}

.submit-success,
.submit-fail {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  padding: 0 30px;

  h3 { color: #e89022; }
  p {
    margin-top: 20px;
    line-height: 22px;
    font-size: 16px;
    color: #4a4a4a;
  }
}

.form-forgetpassword {
  margin: auto;
  width: 350px;
  input {
    display: block;
    margin: 10px 0;
    padding: 10px;
    width: 350px;
    height: 44px;
    background-color: transparent;
    border-bottom: 1px solid #ff9d00;
    font-size: 20px;
    font-weight: 300;
    color: #333;
    transition: all .3s;
    &:-webkit-autofill {
      background-color: #333 !important;
    }
    &[name="email"]:focus {
      margin: 20px 0;
      border-bottom: 2px solid #ed5e00;
    }
  }
  .warning {
    margin-top: 20px;
    width: 100%;
    text-align: right;
    color: #d0011b;
    font-size: 14px;
  }
  .form-submit {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
    width: 100%;
    height: 50px;
    background-color: #d0011b;
    font-size: 17px;
    color: #fff;
    border-radius: 3px;
    cursor: pointer;
    &:hover {
      background-color: darken(#d0011b, 10%);
      transition: all .3s;
    }
  }
}
</style>



// WEBPACK FOOTER //
// Forgetpassword.vue?03f6f06b